import axios from '@/api';

class ShareSubtitleContext {
    async request(file, sync = 0, mediaFile) {
        if (!mediaFile?.shareToken) {
            return false;
        }

        const baseName = file.replace(/\.[^/.]+$/, "");
        const ext = file.split(".").pop().toLowerCase();

        try {
            const response = await axios.post(
                `${process.env.VUE_APP_API_URL}share/subtitle`,
                {
                    fileName: `${baseName}.${ext}`,
                    token: mediaFile.shareToken,
                    dir: mediaFile.shareDir || "",
                    sync,
                },
                {
                    withCredentials: true,
                    responseType: "blob",
                }
            );

            if (
                response.status !== 200 ||
                response.data.type === "application/json"
            ) {
                return false;
            }

            return {
                url: URL.createObjectURL(response.data),
                name: `${baseName}.${ext}`,
                ext: `.${ext}`,
            };
        } catch {
            return false;
        }
    }
}

export default new ShareSubtitleContext();
